import { UploadSimple } from '@phosphor-icons/react'
import React, {
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from 'react'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css'
import { Button } from '../../../../components/common/Button'
import { Input } from '../../../../components/common/Input'
import { Select } from '../../../../components/common/Select'
import { ContextContracts } from '../../../../context/context_contracts'
import {
  ButtonContainer,
  Container,
  Divider,
  PlaceHolderFile,
  Row,
  Section,
  TextAreaContainer,
  Title,
} from './styles'
interface ContractProps {
  id: string
  name: string
  version: string
  text: string
  type: string
}
interface FormEditContractProps {
  handleModalSave: Dispatch<SetStateAction<boolean>>
  handleModalRemove: Dispatch<SetStateAction<boolean>>
}

export const FormEditContract = ({
  handleModalSave,
  handleModalRemove,
}: FormEditContractProps) => {
  const { editItem, updateItem, updateFile } = useContext(ContextContracts)
  console.log('🚀 ~ editItem:', editItem.file)
  const [contractOption, setContractOption] = useState('')
  const [fileName, setFileName] = useState(editItem.file)

  useEffect(() => {
    if (editItem.type === 'TEXT') {
      setContractOption(editItem.text)
    } else {
      setContractOption(editItem.file)
    }
  }, [])

  useEffect(() => {
    setContractOption(editItem.type) // Defina initialmente contractOption com base no tipo de contrato
  }, [editItem.type])

  const [editState, setEditState] = useState(false)

  const [contract, setContract] = useState<ContractProps>(editItem)

  const handleFileChange = (event) => {
    const fileInput = event.target
    if (fileInput.files.length > 0) {
      setFileName(fileInput.files[0].name)
    } else {
      setFileName('Escolher arquivo')
    }
  }

  const handleInputChange = (field, value) => {
    setContract((prevItem) => ({
      ...prevItem,
      [field]: value,
    }))
  }

  const date = new Date(editItem.updated_at)
  const dataFormatada =
    date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear()

  const toggleFunction = (setValue) => {
    setValue((prev) => !prev)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    console.log(contract)
    updateItem(contract)
    toggleFunction(handleModalSave)
  }

  const contractWaysToSave = [
    { id: 'TEXT', value: 'Escrever contrato' },
    { id: 'FILE', value: 'Fazer upload' },
  ]

  return (
    <Container onSubmit={handleSubmit}>
      <Section>
        <Input.Root>
          <Input.Label
            title="Nome do contrato"
            htmlFor="residentContractName"
          />
          <Input.Wrapper>
            <Input.Content
              id="residentContName"
              type="text"
              value={editItem.name}
              onChange={(e) => handleInputChange('name', e.target.value)}
              required={editState}
              readOnly={!editState}
              disabled={!editState}
            />
          </Input.Wrapper>
        </Input.Root>
        <Row>
          <Input.Root>
            <Input.Label
              title="Versão do contrato"
              htmlFor="residentContractVersion"
            />
            <Input.Wrapper>
              <Input.Content
                id="residentContractVersion"
                type="text"
                value={editItem.version}
                readOnly
                disabled
              />
            </Input.Wrapper>
          </Input.Root>
          <Input.Root>
            <Input.Label
              title="Data de atualização"
              htmlFor="residentContractDate"
            />
            <Input.Wrapper>
              <Input.Content
                id="residentContractDate"
                type="text"
                value={'Dia da ação (' + dataFormatada + ')'}
                readOnly
                disabled
              />
            </Input.Wrapper>
          </Input.Root>
        </Row>
      </Section>
      <Divider />
      <Section>
        <Title>Texto do contrato</Title>
        <Select
          onchange={(e) => {
            handleInputChange('type', e.target.value)
            setContractOption(e.target.value)
          }}
          label={{
            title: 'Como você deseja salvar o contrato?',
            htmlFor: '',
            color: '',
            fontSize: '12px',
          }}
          data={contractWaysToSave}
          backgroundcolor=""
          bordercolor="#CECECE"
          currentOption={contractOption}
          outlinecolor=""
          // disabled={!editState}
        />
        {contractOption === 'FILE' ? (
          <Input.Root>
            <Input.Label
              title="Salvar contrato"
              htmlFor="residentContractName"
            />
            <Input.Wrapper>
              <PlaceHolderFile>{fileName}</PlaceHolderFile>
              <Input.Content
                id="residentContName"
                type="file"
                onChange={(e) => {
                  handleFileChange(e)
                  updateFile(e.target.files[0])
                }}
                accept="application/pdf"
                required
              />
              <Input.Icon>
                <UploadSimple size={24} />
              </Input.Icon>
            </Input.Wrapper>

            <a href={editItem.file} target="__blank">
              Baixar contrato
            </a>
            {/* </a> */}
          </Input.Root>
        ) : contractOption === 'TEXT' ? (
          <TextAreaContainer>
            <ReactQuill
              theme="snow"
              value={contract.text}
              onChange={(e) => handleInputChange('text', e)}
            />
          </TextAreaContainer>
        ) : null}
        {editState ? (
          <ButtonContainer>
            <Button.Root
              backgroundColor="#006598"
              type="submit"
              // onClick={() => toggleFunction(setEditState)}
            >
              <Button.Content title="Salvar contrato" />
            </Button.Root>
          </ButtonContainer>
        ) : (
          <ButtonContainer>
            <Button.Root
              backgroundColor="#003E5F"
              type="button"
              onClick={() => toggleFunction(setEditState)}
            >
              <Button.Content title="Editar contrato" />
            </Button.Root>
            <Button.Root
              backgroundColor="#770A00"
              type="button"
              onClick={() => toggleFunction(handleModalRemove)}
            >
              <Button.Content title="Remover contrato" />
            </Button.Root>
          </ButtonContainer>
        )}
      </Section>
    </Container>
  )
}
